import styled, { css } from 'styled-components';
import { Color } from '../../base';

const ButtonWrapper = styled.button`
    padding: 10px 30px;
    background-color: ${Color.red};
    border: 1px solid ${Color.red};
    color: ${Color.white} !important;
    border-radius: 4px;
    display: inline-block;
    font-weight: 600;
    text-align: center;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all ease-in-out .2s;

    &:hover {
      background-color: ${Color.redMediumLight};
    }
    &:focus {
      background-color: ${Color.redMediumDark};
    }

  ${props =>
    props.color === 'white' &&
    css`
      background-color: ${Color.white};
      color: ${Color.red} !important;
      &:hover {
        background-color: ${Color.red};
        color: ${Color.white} !important;
      }
    `}

  ${props =>
    props.outline &&
    css`
      background-color: transparent;
      color: ${Color.red} !important;
      border: 1px solid ${Color.red};
      &:hover {
        background-color: ${Color.red};
        color: ${Color.white} !important;
      }
    `}
  ${props =>
    props.circle &&
    css`
      border-radius: 100px;
    `}

  ${props =>
    props.size === 'large' &&
    css`
      padding: 16px 30px;
    `}
  
  ${props =>
    props.block &&
    css`
      width: 100%;
    `}

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export { ButtonWrapper };
